// extracted by mini-css-extract-plugin
export default {"title":"Task_title__gScrH","tooltip":"Task_tooltip__CfB01"};